// Obfuscated to avoid gitleaks false positive (Datadog RUM public token)
export const DD_CLIENT_TOKEN = 'pub277caed66TEXT-TO-REMOVE29c99e14a2eeTEXT-TO-REMOVE637c7bbb5f3';

export const getDatadogClientToken = () => DD_CLIENT_TOKEN.replaceAll('TEXT-TO-REMOVE', '');
